// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CLOSE_STICKY_RECTANGLE = "zav\u0159\u00edt reklamu";
